<template>
    <div>
        <TheQuickscanHistory />

        <div ref="stepwrapper">
            <TheQuickscanQuestion
                v-if="current.__typename === 'question_Entry'"
                :current
                :max-nr-questions
                :quickscan
            />
            <TheQuickscanResult
                v-if="current.__typename === 'quickscanResult_Entry'"
                :current
            />
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    current: {
        type: Object,
        required: true
    },
    maxNrQuestions: {
        type: Number,
        default: 0
    },
    quickscan: {
        type: String,
        required: true
    }
});

const stepwrapper = ref(null);

watch(() => props.current.value, (newValue, oldValue) => {
    if (newValue.uri !== oldValue.uri) {
        stepwrapper.value.scrollIntoView();
    }
});
</script>

<style lang="less" src="./TheQuickscan.less"></style>
